// GN: setas laterais (‹ ›) sobre os carrosséis de produtos da home (featured-collection do Dawn).
// Só repassam o clique para os botões "anterior/próximo" do próprio Dawn (os de baixo, "‹ 1/3 ›"),
// então a posição e o contador continuam sincronizados. Somem quando não há para onde ir.
(() => {
  const SETA =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function montar(slider) {
    if (slider.dataset.gnSetas) return;
    const secao = slider.closest('.shopify-section');
    const anterior = secao?.querySelector('.slider-button--prev');
    const proximo = secao?.querySelector('.slider-button--next');
    if (!anterior || !proximo) return;
    slider.dataset.gnSetas = '1';
    slider.classList.add('gn-setas');

    const criar = (lado, original) => {
      const botao = document.createElement('button');
      botao.type = 'button';
      botao.className = `gn-seta gn-seta--${lado}`;
      botao.setAttribute('aria-label', original.getAttribute('aria-label') || (lado === 'ant' ? 'Anterior' : 'Próximo'));
      botao.innerHTML = SETA;
      botao.addEventListener('click', () => original.click());
      slider.append(botao);
      const sincronizar = () => {
        botao.hidden = original.hasAttribute('disabled') || original.closest('[hidden]') !== null;
      };
      sincronizar();
      new MutationObserver(sincronizar).observe(original, { attributes: true, attributeFilter: ['disabled'] });
      return botao;
    };
    const setas = [criar('ant', anterior), criar('prox', proximo)];

    // Altura: no meio da foto do produto (a proporção do card muda entre celular e computador).
    // Lê todas as medidas antes de escrever e roda num quadro de animação, para não forçar recálculo de layout.
    let agendado = false;
    const posicionar = () => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(() => {
        agendado = false;
        const foto = slider.querySelector('.card__inner, .card__media');
        if (!foto) return;
        const topo = foto.getBoundingClientRect().top - slider.getBoundingClientRect().top;
        const meio = topo + foto.offsetHeight / 2;
        // A seta escondida mede 0: usa a altura da visível nas duas, para não desalinhar quando ela aparecer
        const altura = Math.max(...setas.map((b) => b.offsetHeight));
        setas.forEach((b) => (b.style.top = `${Math.round(meio - altura / 2)}px`));
      });
    };
    if (document.readyState === 'complete') posicionar();
    else window.addEventListener('load', posicionar, { once: true });
    window.addEventListener('resize', posicionar, { passive: true });
  }

  const iniciar = () =>
    document.querySelectorAll('.featured-collection slider-component, .collection slider-component').forEach(montar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
